import { useEffect, useState } from 'react';
import { Button, Card, Col, Input, Row, Select, Typography, Modal } from 'antd';
import { PlusOutlined, SyncOutlined, SettingOutlined } from '@ant-design/icons';
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';

const { Title, Text } = Typography;
const { Option } = Select;

export default function EvenementComptable() {
    const [editMode, setEditMode] = useState(false);
    const [search, setSearch] = useState('');
    const [moduleFilter, setModuleFilter] = useState('Tous les modules');
    const [modalEvent, setModalEvent] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [nom, setNom] = useState('');
    const [commentaire, setCommentaire] = useState('');
    const [code, setCode] = useState('');
    const [modules, setModules] = useState([]);
    const [ecritures, setEcritures] = useState([]);
    const [selectedEcritures, setSelectedEcritures] = useState([]);
    const [evenements, setEvenements] = useState([]);
    const [evenementExist, setEvenementExist] = useState(false);
    const [evenement, setEvenement] = useState(null);
    const [reload, setReload] = useState(false);

    const filteredEvents = evenements?.filter((e) => {
        const matchesSearch = e.libelle.toLowerCase().includes(search.toLowerCase());
        const matchesModule = moduleFilter === 'Tous les modules' || e.schemas[0].module === moduleFilter;
        return matchesSearch && matchesModule;
    });

    const handleCancel = () => {
        setOpenModal(false);
        setNom('');
        setCommentaire('');
        setCode('');
    };

    useEffect(() => {
        axiosInstance.get(`/api/module/all/comptable`)
            .then((res) => {
                setModules(res.data);
            }).catch((err) => {
                console.log(err);
            });

        axiosInstance.get(`/api/schema-ecriture-comptable`)
            .then((res) => {
                setEcritures(res.data);
            }).catch((err) => {
                console.log(err);
            });
        axiosInstance.get(`/api/evenement-comptable`)
            .then((res) => {
                setEvenements(res.data);
            }).catch((err) => {
                console.log(err);
            });
    }, [reload]);

    const handleAdd = () => {
        if (evenementExist) {
            toast.error("Le code de l'événement existe deja !");
        } else {
            setLoading(true);
            const event = {
                ...evenement,
                libelle: nom,
                description: commentaire,
                code: code,
                schemas: ecritures.filter((e) => selectedEcritures.includes(e.schemaEcritureComptableId)),
            }
            // console.log(event);
            if (editMode) {
                axiosInstance.put('/api/evenement-comptable', event)
                    .then((res) => {
                        // console.log("Event added successfully:", res.data);
                        toast.success("Événement modifiée avec succès !");
                        // Optionally, refresh the tree data or update state to reflect the new event
                        handleCancel();
                        setReload(true);
                        setLoading(false);
                    })
                    .catch((err) => {
                        console.error("Error adding event:", err);
                        setLoading(false);
                    });
            } else {
                axiosInstance.post('/api/evenement-comptable', event)
                    .then((res) => {
                        // console.log("Event added successfully:", res.data);
                        toast.success("Événement ajouté avec succès !");
                        // Optionally, refresh the tree data or update state to reflect the new event
                        setEvenements([...evenements, res.data]);
                        handleCancel();
                        setReload(true);
                        setLoading(false);
                    })
                    .catch((err) => {
                        console.error("Error adding event:", err);
                        setLoading(false);
                    });
            }

        }

    }

    const existingEvenement = (event) => {
        axiosInstance.get(`/api/evenement-comptable/check/code/${event}`)
            .then((res) => {
                if (res.data) {
                    toast.error("Le code de l'événement existe deja !");
                    setEvenementExist(true);
                } else {
                    setEvenementExist(false);
                }
            })
            .catch((err) => {
                console.error("Checking event:", err);
            });
    }

    return (
        <div className="p-6">
            <Card>
                <Row justify="space-between" align="middle" className="mb-6">
                    <Title level={4}>Événements Comptables</Title>
                    <div className="flex gap-3">
                        <Button onClick={() => setOpenModal(true)} type="primary" icon={<PlusOutlined />}>
                            Nouvel Événement
                        </Button>
                        <Button icon={<SyncOutlined />}>Actualiser</Button>
                    </div>
                </Row>

                <Row gutter={16} className="mb-6">
                    <Col xs={24} md={12}>
                        <label>Filtrer par module: </label>
                        <Select
                            value={moduleFilter}
                            onChange={(v) => setModuleFilter(v)}
                            className="w-full"
                            style={{ width: '40%' }}
                        >
                            <Option value="Tous les modules">Tous les modules</Option>
                            {modules?.map((m) => <Option value={JSON.stringify(m)}>{m?.nom}</Option>)}
                        </Select>
                    </Col>
                    <Col xs={24} md={12}>
                        <label>Rechercher</label>
                        <Input
                            placeholder="Nom de l'événement..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </Col>
                </Row>

                <Row gutter={[16, 16]}>
                    {evenements?.map((event, idx) => (
                        <Col xs={24} md={12} lg={8} key={idx}>
                            <Card
                                title={<Text className="text-blue-800">{event.code}</Text>}
                                bordered
                            >
                                <p>
                                    <Text type="secondary">Intitulé:</Text> <Text>{event.libelle}</Text>
                                </p>
                                <p>
                                    <Text type="secondary">Schéma(s) associé(s):</Text>{' '}
                                    <Text className="text-blue-600">{event.schemas.map((s) => s.code).join(', ')}</Text>
                                </p>
                                <p>
                                    <Text type="secondary">Description:</Text>
                                    <br />
                                    <Text>{event.description}</Text>
                                </p>
                                <div className="flex justify-end mt-4">
                                    <Button
                                        type="link"
                                        icon={<SettingOutlined />}
                                        onClick={() => setModalEvent(event)}
                                    >
                                        Configurer
                                    </Button>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Card>

            {/* Modal Config */}
            {modalEvent && (
                <Modal
                    title={`Configuration de ${modalEvent.libelle}`}
                    open={true}
                    onCancel={() => setModalEvent(null)}
                    footer={[
                        <Button key="cancel" onClick={() => setModalEvent(null)}>
                            Fermer
                        </Button>,
                        <Button key="submit" type="primary" onClick={() => {
                            setEditMode(true);
                            setEvenement(modalEvent);
                            setNom(modalEvent.libelle);
                            setCode(modalEvent.code);
                            setCommentaire(modalEvent.description);
                            setSelectedEcritures(modalEvent.schemas.map((s) => s.schemaEcritureComptableId));
                            setOpenModal(true);
                            setModalEvent(null);
                        }}
                        >
                            Editer
                        </Button>,
                    ]}
                >
                    <p><strong>Code:</strong> {modalEvent.code}</p>
                    <p><strong>Intitulé:</strong> {modalEvent.libelle}</p>
                    <p><strong>Schéma(s) associé(s):</strong> {modalEvent.schemas.map((s) => s.code).join(', ')}</p>
                    <p><strong>Description:</strong> {modalEvent.description}</p>
                </Modal>
            )}
            <Modal
                title={editMode ? "Editer l'évènement comptable" : "Ajouter un évènement comptable"}
                open={openModal}
                onOk={handleAdd}
                onCancel={handleCancel}
                loading={loading}
                okText="Enregistrer"
                cancelText="Annuler"
                width={800}
            >
                <div className="row">
                    <div className="col-8">
                        <div class="mb-3">
                            <label for="nom" class="form-label">Nom de l'évènement comptable</label>
                            <input type="text" class="form-control" placeholder="Nom de l'évènement comptable" id="nom" value={nom} onChange={(e) => setNom(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-4">
                        <div class="mb-3">
                            <label for="code" class="form-label">Code</label>
                            <input type="text" class="form-control" placeholder="Code" id="code" value={code}
                                onChange={(e) => {
                                    setCode(e.target.value);
                                    existingEvenement(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <label for="schemas" class="form-label">Schémas</label>
                        <Select
                            name="selectedEcritures"
                            onChange={(value) => setSelectedEcritures(value)}
                            placeholder="Selectionner les schémas"
                            style={{ width: "100%" }}
                            mode='multiple'
                            value={selectedEcritures}
                        >
                            {ecritures?.map((option, index) => (
                                <Option key={index} value={option?.schemaEcritureComptableId}>
                                    {option.label}
                                </Option>
                            ))}
                        </Select>
                    </div>
                    <div class="col-12 mb-3">
                        <label for="commentaire" class="form-label">Description</label>
                        <textarea
                            class="form-control"
                            id="commentaire"
                            placeholder="Description de l'évènement"
                            value={commentaire}
                            onChange={(e) => setCommentaire(e.target.value)}
                        ></textarea>
                    </div>
                </div>


            </Modal>
        </div>
    );
}
